import { render } from "./LandingPage.vue?vue&type=template&id=0d046b29&scoped=true"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=0d046b29&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d046b29"]])

export default __exports__